/**
 * Shopify Sync API - handles store sync operations
 *
 * TODO: These are currently dummy stubs returning mock data.
 * Replace with real API calls once the Shopify sync backend is migrated
 * from the old Onrender service to the new FastAPI backend.
 */

/**
 * Fetch store sync information.
 * @returns {Promise<object>} mock store info
 */
export async function getStoreInfo() {
  return {
    pages_synced: 0,
    pages_total: 0,
    blogs_synced: 0,
    blogs_total: 0,
    products_count: 0,
    collections_count: 0,
    last_synced_at: null,
    shop_domain: '',
  };
}

/**
 * Trigger initial sync for a Shopify store.
 * @returns {Promise<object>} mock sync result
 */
export async function initialSync() {
  return { pages_saved: 0, sync_time: '', message: 'Sync not yet implemented' };
}

/**
 * Manually sync store pages.
 * @returns {Promise<object>} mock sync result
 */
export async function syncPages() {
  return { synced_count: 0, total_count: 0 };
}

/**
 * Manually sync blog articles.
 * @returns {Promise<object>} mock sync result
 */
export async function syncArticles() {
  return { synced_count: 0, total_count: 0 };
}
